import axios from "@axios" //eslint-disable-line

export default {
    /*
     * main custom links API
     */
    getCustomLinks() {
        return axios.get('/links')
    },
    addCustomLink(data) {
        return axios.post('/links', data)
    },
    getCustomLink(uuid) {
        return axios.get(`/links/${uuid}`)
    },
    updateCustomLink(uuid, data) {
        return axios.put(`/links/${uuid}`, data)
    },
}
